export type Locale = 'en' | 'sv';

export const translations = {
	en: {
		searchPlaceholder: 'Search 500,000+ games…',
		discover: 'Discover',
		allGames: 'All Games',
		resultsFor: 'Results for',
		games: 'Games',
		genres: 'Genres',
		allGenres: 'All genres',
		platforms: 'Platforms',
		allPlatforms: 'All platforms',
		orderBy: 'Order by',
		relevance: 'Relevance',
		dateAdded: 'Date added',
		name: 'Name',
		releaseDate: 'Release date',
		popularity: 'Popularity',
		averageRating: 'Average rating',
		releaseDateLabel: 'Release Date',
		developers: 'Developers',
		publishers: 'Publishers',
		gameDetails: 'Game Details',
		game: 'Game',
		details: 'Details',
		couldNotLoad: 'Could not load games. Check your API connection.',
		tba: 'TBA',
		avgPlaytime: 'avg',
		ratings: 'ratings',
		released: 'Released',
		hAvgPlaytime: 'h avg playtime',
		hAvgShort: 'h avg',
	},
	sv: {
		searchPlaceholder: 'Sök bland 500 000+ spel…',
		discover: 'Upptäck',
		allGames: 'Alla spel',
		resultsFor: 'Resultat för',
		games: 'Spel',
		genres: 'Genrer',
		allGenres: 'Alla genrer',
		platforms: 'Plattformar',
		allPlatforms: 'Alla plattformar',
		orderBy: 'Sortera efter',
		relevance: 'Relevans',
		dateAdded: 'Datum tillagt',
		name: 'Namn',
		releaseDate: 'Utgivningsdatum',
		popularity: 'Popularitet',
		averageRating: 'Medelbetyg',
		releaseDateLabel: 'Utgivningsdatum',
		developers: 'Utvecklare',
		publishers: 'Utgivare',
		gameDetails: 'Speldetaljer',
		game: 'Spel',
		details: 'Detaljer',
		couldNotLoad: 'Kunde inte ladda spel. Kontrollera API-anslutningen.',
		tba: 'TBA',
		avgPlaytime: 'snitt',
		ratings: 'betyg',
		released: 'Utgivet',
		hAvgPlaytime: 'h snittspeltid',
		hAvgShort: 'h snitt',
	},
} as const;

export type TranslationKey = keyof typeof translations.en;
